// fmt$ lives in /js/shared/money.js (a classic script loaded before this
// bundle) because catalog.html need it too and
// can't import ES modules. It's a bare global here, same as ageAsOfSept1.
//
// readMoney is the input side of the same story: every price field in the
// portal is a `.money` text input, so what comes back is whatever the person
// typed. It accepts "15", "15.5", "$15.00", "1,500" and rejects the rest with
// null, so callers can say so instead of posting a silently-wrong number.
export function readMoney(el) {
  const raw = (el.value || '').replace(/[$,\s]/g, '');
  if (raw === '') return 0;
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

// The other direction: a stored amount going back into a `.money` field. Always
// shows cents, the way fmt$ does, so a class saved at 12.50 re-opens as "12.50"
// rather than the bare JSON number 12.5. Anything blank or non-numeric renders
// as empty, which leaves the field's placeholder visible.
export const moneyValue = v =>
  v === null || v === undefined || v === '' || !Number.isFinite(Number(v)) ? '' : Number(v).toFixed(2);

export const TODAY = new Date();

export const calcAge = dob => {
  if (!dob) return '—';
  const d = new Date(dob + 'T00:00');
  let age = TODAY.getFullYear() - d.getFullYear();
  const m = TODAY.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && TODAY.getDate() < d.getDate())) age--;
  return age;
};

export const fmtD = iso => new Date(iso + 'T00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
export const fmtLocalDT = utcIso => {
  if (!utcIso) return '—';
  const d = new Date(utcIso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    + ' at ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
};

window.TODAY = TODAY;
window.calcAge = calcAge;
window.fmtD = fmtD;
window.fmtLocalDT = fmtLocalDT;
